import * as signalR from '@microsoft/signalr';

class SignalRService {
  constructor() {
    this.connection = null;
    this.callbacks = new Map();
  }

  initialize() {
    if (this.connection) return;

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl('https://services.solucore.com/solutrakapi/hub')
      .withAutomaticReconnect()
      .build();

    console.log('SignalR connection initialized');

    this.connection.onclose(() => {
      console.log('SignalR connection closed');
    });
  }

  async start() {
    if (!this.connection) {
      this.initialize();
    }
    try {
      if (this.connection.state === signalR.HubConnectionState.Disconnected) {
        await this.connection.start();
        console.log('SignalR connected successfully');
      }
      return true;
    } catch (error) {
      console.error('State: ', this.connection.state);
      console.error('Error starting SignalR connection:', error);
      return false;
    }
  }

  async stop() {
    if (this.connection && this.connection.state === signalR.HubConnectionState.Connected) {
      try {
        await this.connection.stop();
        console.log('SignalR connection stopped');
      } catch (error) {
        console.error('Error stopping SignalR connection:', error);
      }
    }
  }

  async subscribeToGroup(groupId) {
    if (!this.connection || this.connection.state !== signalR.HubConnectionState.Connected) {
      await this.start();
    }

    try {
      await this.connection.invoke('AddConnectionIdToGroup', groupId.toString());
      console.log(`Subscribed to group: ${groupId}`);
      return true;
    } catch (error) {
      console.error(`Error subscribing to group ${groupId}:`, error);
      return false;
    }
  }

  on(eventName, callback) {
    if (!this.connection) {
      this.initialize();
    }

    // Store the callback in our map for potential cleanup
    if (!this.callbacks.has(eventName)) {
      this.callbacks.set(eventName, []);
    }
    this.callbacks.get(eventName).push(callback);

    // Register the callback with SignalR
    this.connection.on(eventName, (data) => {
      callback(data);
    });

    return () => this.off(eventName, callback);
  }

  off(eventName, callback) {
    if (!this.connection) return;

    if (callback && this.callbacks.has(eventName)) {
      // Remove specific callback
      const callbacks = this.callbacks.get(eventName);
      const index = callbacks.indexOf(callback);
      if (index !== -1) {
        callbacks.splice(index, 1);
      }
      this.connection.off(eventName, callback);
    } else {
      // Remove all callbacks for this event
      this.callbacks.delete(eventName);
      this.connection.off(eventName);
    }
  }
}

// Create a singleton instance
const signalRService = new SignalRService();

export default signalRService;
